import { render, staticRenderFns } from "./saddleRoom.vue?vue&type=template&id=30d9a162&scoped=true&lang=pug"
import script from "./saddleRoom.vue?vue&type=script&lang=js"
export * from "./saddleRoom.vue?vue&type=script&lang=js"
import style0 from "./saddleRoom.vue?vue&type=style&index=0&id=30d9a162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d9a162",
  null
  
)

export default component.exports